import {createContext} from 'react';

const UserBasicInfoContext = createContext("Loading...");
export default UserBasicInfoContext;